import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { NodeSelection } from '@atlaskit/editor-prosemirror/state';
import { findParentNode } from '@atlaskit/editor-prosemirror/utils';
import { fg } from '@atlaskit/platform-feature-flags';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { getAIExperienceButton, getPremiumAIButton } from '../../pm-plugins/floating-toolbar-button/floating-toolbar-button';
import { InlineSuggestionToolbar } from '../../pm-plugins/inline-suggestions/floating-toolbar/floating-toolbar';
import { getSupportedNodesForAIModal } from '../utils/ai-button';
export var getFloatingToolbarConfig = function getFloatingToolbarConfig(_ref) {
  var aiGlobalOptIn = _ref.aiGlobalOptIn,
    editorPluginAIProvider = _ref.editorPluginAIProvider,
    api = _ref.api;
  return (
    // eslint-disable-next-line @typescript-eslint/max-params
    function (state, intl, _providerFactory, processedConfigs) {
      var _api$connectivity;
      if (editorExperiment('editor_ai_inline_suggestion_date', 'test')) {
        var suggestionToolbar = InlineSuggestionToolbar.maybeBuild(state, api);
        if (suggestionToolbar) {
          return suggestionToolbar;
        }
      }

      /**
       * Add AI button in nodes supported (currently only table is supported).
       * List of supported node can be found in implementation of getSupportedNodesForAIModal.
       */
      var selection = state.selection;
      var from = selection.from,
        to = selection.to;
      var isNodeSelection = selection instanceof NodeSelection;
      var isCellSelection = selection.toJSON().type === 'cell';
      var getParentSupportedForAIButton = function getParentSupportedForAIButton() {
        var supportedNodesForAI = getSupportedNodesForAIModal(state);
        if (isNodeSelection) {
          return supportedNodesForAI.has(selection.node.type) ? selection.node : undefined;
        } else {
          var parentNodeFindResult = findParentNode(function (node) {
            return supportedNodesForAI.has(node.type);
          })(selection);
          return parentNodeFindResult === null || parentNodeFindResult === void 0 ? void 0 : parentNodeFindResult.node;
        }
      };
      var disabled = fg('platform_editor_offline_editing_mvp') && (api === null || api === void 0 || (_api$connectivity = api.connectivity) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.sharedState) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.currentState()) === null || _api$connectivity === void 0 ? void 0 : _api$connectivity.mode) === 'offline';
      var parentSupportedForAIButton = getParentSupportedForAIButton();
      if ((from === to || isNodeSelection || isCellSelection) && parentSupportedForAIButton) {
        var canAddAIButton = isNodeSelection || parentSupportedForAIButton;
        var nodeType = parentSupportedForAIButton === null || parentSupportedForAIButton === void 0 ? void 0 : parentSupportedForAIButton.type;
        if (canAddAIButton && nodeType) {
          var aiIconButton =
          // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
          fg('ai-smart-button-team-25') || editorExperiment('platform_editor_controls', 'variant1') ? getPremiumAIButton({
            intl: intl,
            rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
            aiGlobalOptIn: aiGlobalOptIn,
            triggeredFor: nodeType,
            disabled: disabled
          }) : getAIExperienceButton({
            intl: intl,
            rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
            hideTitle: true,
            aiGlobalOptIn: aiGlobalOptIn,
            triggeredFor: nodeType,
            disabled: disabled
          });
          var addAIButtonToConfig = function addAIButtonToConfig(title) {
            var toolbarConfig = processedConfigs === null || processedConfigs === void 0 ? void 0 : processedConfigs.find(function (config) {
              return config.title === title;
            });
            var items = Array.isArray(toolbarConfig === null || toolbarConfig === void 0 ? void 0 : toolbarConfig.items) ? toolbarConfig === null || toolbarConfig === void 0 ? void 0 : toolbarConfig.items : [];
            if (toolbarConfig && items.length) {
              var withAIItems =
              // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
              fg('ai-smart-button-team-25') || editorExperiment('platform_editor_controls', 'variant1') ? [aiIconButton, {
                type: 'separator'
              }].concat(_toConsumableArray(items)) : [].concat(_toConsumableArray(items.slice(0, items.length - 3)), [aiIconButton, {
                type: 'separator'
              }], _toConsumableArray(items.slice(items.length - 3, items.length)));
              /**
               * Updating items of table, panel, layout or expand config item.
               * Injecting updated items in same config object.
               */
              toolbarConfig.items = withAIItems;
              return toolbarConfig;
            }
          };

          /**
           * Here we are updating items of table, panel, expand and layout
           * 	floaingToolbarConfig.
           * This will only work when editor-plugin-ai is added after these plugins.
           * Proper solution will be implemented when outcome
           * 	of https://hello.atlassian.net/wiki/spaces/EDITOR/pages/4166466469/Editor+RFC+058+Easier+way+to+insert+items+in+floating+toolbar
           *  RFC is finalised.
           */
          var toolbarConfig = addAIButtonToConfig('Table floating controls');
          if (toolbarConfig) {
            return toolbarConfig;
          }
        }
      }
      return;
    }
  );
};